<template>
	<div class="w1200 flex flex-direction align-stretch benben-flex-layout bind">
	    <div class="flex bind_1">
	    	<div class="flex benben-flex-layout flex-wrap align-center pointer " @click="caozuo(1)">
	    		<img class="bind_1_1" src="https://api.ezlunch.club/pc/image/13.png" alt="" srcset="">
	    		<div class="bind_1_2">{{$t('返回')}}</div>
	    	</div>
	    </div>
		<div class="bind_2">{{$t('绑定企业')}}</div>
		<div class="bind_3">{{$t('绑定企业后，不可修改，请谨慎操作')}}</div>
		<div class="flex bind_4">
			<el-input class="bind_4_1" v-model="input1" :placeholder="$t('请输入企业名称')"></el-input>
		    <div class="bind_4_2 pointer" @click="caozuo(2)">{{$t('搜索')}}</div>
		</div>
		
		<div v-loading="loading"  :element-loading-text="$t('拼命加载中')">
			<div v-if="si_list.length > 0">
				<template v-for="(item,index) in si_list">
					<div class="bind_5 flex benben-flex-layout flex-wrap align-center">
						<div class="bind_5_1 flex-sub">{{item.name}}</div>
						<div class="bind_5_2 pointer" @click="caozuo(3,item)">{{$t('绑定')}}</div>
					</div>
				</template>
			</div>
			<div v-else style="text-align: center;padding: 40px 0;">
				<img style="width: 217px;height: 177px;" src="https://api.ezlunch.club/pc/image/29.png" alt="" srcset="">
			</div>
			<div v-if="si_list.length > 0" style="text-align: center;margin: 20px  0;">
				<el-pagination
				   @current-change="handleCurrentChange"
				   layout="prev, pager, next"
				   :current-page.sync="page" :page-size="page_size"
				   :total="total">
				 </el-pagination>
			</div>
		</div>
		
		
		
		
		<el-dialog class="footer_6" title="" :visible.sync="visible3" width="460px" >
			<div class="choiceFood_9">
				<div class="flex align-center justify-between benben-flex-layout choiceFood_9_1">
					<div class="choiceFood_9_2">{{$t('温馨提示')}}</div>
				</div>
				<div class="fflex flex-direction align-stretch benben-flex-layout choiceFood_17" >
					<div class="choiceFood_15">{{$t('确定绑定')}}{{si_item.name}}{{$t('吗')}}？{{$t('提交绑定后，将不可修改请谨慎操作')}}</div>
					<div class="flex choiceFood_16">
						<div class="choiceFood_16_1 pointer" @click="visible3 = false">{{$t('取消')}}</div>
						<div class="choiceFood_16_2 pointer" @click="post68d0ab0b58894">{{$t('确认')}}</div>
					</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
				total:0,
				page:1,
				page_size:10,
				loading:true,
				visible3:false,
				input1:'',
				si_list:[],
				si_item:'',
			}
		},
		created() {
			if(window.sessionStorage.getItem('token')){
				this.post68caa25b2cb19()
			}else{
				this.$router.push({
					name: 'login',
				});
			}
			
		},

		methods: {
			gengxin(){
				this.loading = true
				this.post68caa25b2cb19()
			},
			// 提交企业绑定
			post68d0ab0b58894(){
				this.$api.post(this.$apiUrls.post68d0ab0b58894,{company_id:this.si_item.aid}).then((res) => {
					if(res.code == 1){
						this.caozuo(1)
					}else{
						this.$message.error(res.msg);
						return
					}
				})
			},
			// 切换页面
			handleCurrentChange(val){
				this.page = val
				this.post68caa25b2cb19()
			},
			//查询企业列表
			post68caa25b2cb19(){
				this.$api.post(this.$apiUrls.post68caa25b2cb19,{page:this.page,list_rows:this.page_size,name:this.input1}).then((res) => {
					if(res.code == 1){
						this.si_list = res.data.data
						this.total = res.data.total
						this.loading = false
					}else{
						this.$message.error(res.msg);
						return
					}
				})
			},
			caozuo(type,item){
				if(type == 1){
					window.history.back();
					return
					this.$router.push({
						name: 'myinfo',
					});
				}else if(type == 2){
					this.post68caa25b2cb19()
				}else if(type == 3){
					this.si_item = item
					this.visible3 = true
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	::v-deep {
		.bind_4_1{
			.el-input__inner{
				background: #F8F8FA;
				border: none ;
			}
		}
		.footer_6{
			.el-dialog__header{
				display: none;
			}
			.el-dialog__body{
				padding: 0 !important;
				border-radius: 16px 16px 16px 16px;
				// background: rgba(187,195,211,0) !important;
			}
		}
		.el-loading-mask {
			opacity: 1 !important; 
			background-color: rgba(255, 255, 255, 1) !important;
		}
	}
	.bind{
		margin-top: 20px;
		padding: 0 20px 100px;
		background: #fff;
	}
	.bind_1{
		padding: 20px 0;
		border-bottom: 1px solid #EEEEEE;
	}
	.bind_1_1{
		width: 14px;
		height: 14px;
	}
	.bind_1_2{
		font-weight: 500;
		font-size: 14px;
		color: #666666;
		margin-left: 10px;
	}
	.bind_2{
		font-weight: 500;
		font-size: 16px;
		color: #1A1A1A;
		margin: 24px 0 0 0 ;
	}
	.bind_3{
		font-weight: 400;
		font-size: 14px;
		color: #999999;
		margin: 8px 0 0 0;
	}
	.bind_4{
		margin: 24px 0 0 0;
	}
	.bind_4_1{
		width: 352px;
		height: 40px;
		background: #F8F8FA;
		border-radius: 6px 6px 6px 6px;
		margin: 0 16px 0 0;
	}
	.bind_4_2{
		width: 104px;
		height: 40px;
		background: #FF770F;
		border-radius: 8px 8px 8px 8px;
		text-align: center;
		line-height: 40px;
		font-weight: 400;
		font-size: 14px;
		color: #FFFFFF;
	}
	.bind_5{
		border-bottom: 1px solid #EEEEEE;
		padding: 26px 0;
	}
	.bind_5_1{
		font-weight: 400;
		font-size: 14px;
		color: #333333;
	}
	.bind_5_2{
		border: 1px solid #FF770F;
		// width: 88px;
		height: 32px;
		border-radius: 6px 6px 6px 6px;
		border: 1px solid #FF770F;
		text-align: center;
		line-height: 32px;
		padding: 0 30px;
		font-weight: 400;
		font-size: 14px;
		color: #FF770F;
	}
	.choiceFood_9{
		width: 560px;
		// height: 573px;
		padding: 0 0 40px 0;
		background: #FFFFFF;
		border-radius: 8px 8px 8px 8px;
	}
	.choiceFood_9_1{
		width: 100%;
		height: 56px;
		background: #F3F3F3;
		border-radius: 8px 8px 0px 0px;
		padding: 0 20px;
	}
	.choiceFood_9_2{
		font-weight: bold;
		font-size: 16px;
		color: #333333;
	}
	.choiceFood_17{
		padding: 0 20px;
	}
	.choiceFood_15{
		font-weight: bold;
		font-size: 16px;
		color: #333333;
		margin: 20px 0 24px 0;
	}
	.choiceFood_16_1{
		width: 100px;
		height: 36px;
		border-radius: 4px 4px 4px 4px;
		border: 1px solid #CCCCCC;
		text-align: center;
		line-height: 36px;
		font-weight: 400;
		font-size: 14px;
		color: #333333;
		margin: 0 20px 0 auto;
	}
	.choiceFood_16_2{
		width: 100px;
		height: 36px;
		background: #FF770F;
		border-radius: 4px 4px 4px 4px;
		text-align: center;
		line-height: 36px;
		font-weight: 400;
		font-size: 14px;
		color: #FFFFFF;
	}
</style>